var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.5C5.25 6.90326 5.48705 6.33097 5.90901 5.90901C6.33097 5.48705 6.90326 5.25 7.5 5.25H16.5C17.0967 5.25 17.669 5.48705 18.091 5.90901C18.5129 6.33097 18.75 6.90326 18.75 7.5V16.5C18.75 17.0967 18.5129 17.669 18.091 18.091C17.669 18.5129 17.0967 18.75 16.5 18.75H7.5C6.90326 18.75 6.33097 18.5129 5.90901 18.091C5.48705 17.669 5.25 17.0967 5.25 16.5V7.5Z",
    stroke: "url(#paint0_linear_203_3554)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8158L11.4783 15.5L16 8.5",
    stroke: "url(#paint1_linear_203_3554)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_3554",
    x1: 16.0096,
    y1: 5.25,
    x2: 5.07985,
    y2: 11.3243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_3554",
    x1: 14.3761,
    y1: 8.5,
    x2: 8.33553,
    y2: 12.3366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckChecked);
export default __webpack_public_path__ + "static/media/check-checked.d45d1b00215ef8eb45203310ea976caa.svg";
export { ForwardRef as ReactComponent };